	<template>
		<div class="adminkeyword">
			<van-tabs v-model="active" color='#333333' line-width="56px" style="border-bottom: 1px solid #eeeeee;" @click="onClick">
				<van-tab title="雷克萨斯"></van-tab>
				<van-tab title="竞品品牌"></van-tab>
				<van-tab title="" :disabled='true'></van-tab>
				<van-tab title="" :disabled='true'></van-tab>
			</van-tabs>
			<div class="search_resu" style="margin-top: 20px">
				<div class="home_title">数据概览</div>
				<div class="home_stat">
					<div class="home_stat_top">
						<div class="home_stat_text">
							<div>今日</div>
							<div>发帖</div>
							<div style="font-size: 16px;margin-top: 10px">{{top_bbs.number}}</div>
						</div>
						<div class="home_stat_text" style="background-color: #f8f8f8;">
							<div>今日</div>
							<div>评论</div>
							<div style="font-size: 16px;margin-top: 10px">{{top_comment.number}}</div>
						</div>
						<div class="home_stat_text">
							<div>监测</div>
							<div>论坛</div>
							<div style="font-size: 16px;margin-top: 10px">{{top_bbs_type.number}}</div>
						</div>
						<div class="home_stat_text" style="background-color: #f8f8f8;">
							<div>监测</div>
							<div>命中关键词</div>
							<div style="font-size: 16px;margin-top: 10px">{{top_keyword.number}}</div>
						</div>
					</div>
					<div class="home_stat_bottom">
						<div class="home_stat_text">
							<div :class="top_bbs.day_proportion>0?'home_stat_green':top_bbs.day_proportion<0?'home_stat_red':''">日：{{top_bbs.day_proportion}}%</div>
							<div :class="top_bbs.week_proportion>0?'home_stat_green':top_bbs.week_proportion<0?'home_stat_red':''">周：{{top_bbs.week_proportion}}%</div>
							<div :class="top_bbs.month_proportion>0?'home_stat_green':top_bbs.month_proportion<0?'home_stat_red':''">月：{{top_bbs.month_proportion}}%</div>
						</div>
						<div class="home_stat_text" style="background-color: #f8f8f8;">
							<div :class="top_comment.day_proportion>0?'home_stat_green':top_comment.day_proportion<0?'home_stat_red':''">日：{{top_comment.day_proportion}}%</div>
							<div :class="top_comment.week_proportion>0?'home_stat_green':top_comment.week_proportion<0?'home_stat_red':''">周：{{top_comment.week_proportion}}%</div>
							<div :class="top_comment.month_proportion>0?'home_stat_green':top_comment.month_proportion<0?'home_stat_red':''">月：{{top_comment.month_proportion}}%</div>
						</div>
						<div class="home_stat_text">
							<div :class="top_bbs_type.day_proportion>0?'home_stat_green':top_bbs_type.day_proportion<0?'home_stat_red':''">日：{{top_bbs_type.day_proportion}}%</div>
							<div :class="top_bbs_type.week_proportion>0?'home_stat_green':top_bbs_type.week_proportion<0?'home_stat_red':''">周：{{top_bbs_type.week_proportion}}%</div>
							<div :class="top_bbs_type.month_proportion>0?'home_stat_green':top_bbs_type.month_proportion<0?'home_stat_red':''">月：{{top_bbs_type.month_proportion}}%</div>
						</div>
						<div class="home_stat_text" style="background-color: #f8f8f8;">
							<div :class="top_keyword.day_proportion>0?'home_stat_green':top_keyword.day_proportion<0?'home_stat_red':''">日：{{top_keyword.day_proportion}}%</div>
							<div :class="top_keyword.week_proportion>0?'home_stat_green':top_keyword.week_proportion<0?'home_stat_red':''">周：{{top_keyword.week_proportion}}%</div>
							<div :class="top_keyword.month_proportion>0?'home_stat_green':top_keyword.month_proportion<0?'home_stat_red':''">月：{{top_keyword.month_proportion}}%</div>
						</div>
					</div>
				</div>
			</div>
			<div class="search_resu">
				<div class="home_title">
					趋势图表<div class="home_title_info"><van-icon name="info-o" />当前显示数据为7日内数据</div>
				</div>
				<!-- <div class="pop_state">
					<img class="pop_close" @click="closePop()" :src="img.close">
					<div class="pop_state_title">趋势图表</div>
					<div style="font-size: 10px;margin-top: 5px;">昨日访问小程序内所有页面的用户总数，同一用户多次访问不重复计入</div>
					<div></div>
					<div></div>
				</div> -->
				<div class="result_box">
					<div class="result_box_title">
						<div class="result_left">全部监测论坛</div>
					</div>
					<div class="keyword_box">
						<div id="myChart" style="width: 100%;height:300px;margin-top: 15px;"></div>
					</div>
				</div>
			</div>
			<!-- <div class="search_resu">
				<div class="home_title">检测概览</div>
				<div class="result_box">
					<div class="result_title">
						<div class="result_left">检测项目</div>
						<div class="result_right">汇总数量</div>
					</div>
					<div class="result_text result_text_active">
						<div class="result_left">监测论坛</div>
						<div class="result_right">15个</div>
					</div>
					<div class="result_text">
						<div class="result_left">监测帖子</div>
						<div class="result_right">1203篇</div>
					</div>
					<div class="result_text result_text_active">
						<div class="result_left">监测评论</div>
						<div class="result_right">1220个</div>
					</div>
					<div class="" style="display: flex;align-items: center;border-top:1px solid #EEEEEE;margin-top: 10px;">
						<div class="result_time">监测时间范围:{{homeinfo.time}}</div>
					</div>
				</div>
			</div> -->
			<div class="search_resu">
				<div class="home_title">活跃论坛 TOP3
					<div class="home_title_info">
						<van-icon name="info-o" />
					新增帖子数量最多的论坛</div></div>
					<div class="result_box">
						<div class="result_title">
							<div class="result_left">论坛名称</div>
							<div class="result_right">帖子数</div>
						</div>
						<div v-for="(item, index) in bbs_type_list" :key="'list_' + index">
							<div :class="index==1?'result_text':'result_text result_text_active'" @click="goWarnimg(item.type)">
								<div class="result_left" style="text-decoration:underline;">{{item.name}}</div>
								<div class="result_right">{{item.number}}</div>
							</div>
						</div>
						<div class="" style="display: flex;align-items: center;border-top:1px solid #EEEEEE;margin-top: 10px;">
							<div class="result_time">监测时间范围:最近7天</div>
							<!-- {{homeinfo.time}} -->
							<div class="check_more" @click="goPage('adminmorelist')">查看更多论坛>></div>
						</div>
					</div>
				</div>
				<div class="search_resu">
					<div class="home_title">
						活跃帖子 TOP3 
						<div class="home_title_info">
							<van-icon name="info-o" />
						评论数量最多的帖子</div>
					</div>
					<div class="bbs_box">
						<div class="result_bbsbox" v-for="item in bbs_list" :key="'listb_' + item.id" @click="goBbs(item.id)">
							<div class="result_bbstit">{{item.name}}
								<img class="result_title_bage" v-if="item.label_two.type==2" :src="img.new">
								<img class="result_title_bage" v-if="item.label.type==1&&item.label.name=='1级'" :src="img.level1">
								<img class="result_title_bage" v-if="item.label.type==1&&item.label.name=='2级'" :src="img.level2">
								<img class="result_title_bage" v-if="item.label.type==1&&item.label.name=='3级'" :src="img.level3">
								<img class="result_title_bage" v-if="item.label.type==3" :src="img.hot">
								<img class="result_title_bage" v-if="item.label.type==4" :src="img.vie">
							</div>
							<div class="result_bbstime">
								<div style="flex: 1;">{{item.post_time}}</div>
								<div class="f-r">
									<span>阅读{{item.read_num}}</span>
									<span style="margin-left: 20px;">评论{{item.comment_num}}</span>
								</div>
							</div>
						</div>
						<div class="" style="display: flex;align-items: center;border-top:1px solid #EEEEEE;margin-top: 10px;">
							<div class="result_time">监测时间范围:最近7天</div>
							<!-- {{homeinfo.time}} -->
							<div class="check_more" @click="goMorebbs()">查看更多帖子>></div>
						</div>
					</div>
				</div>
			</div>
			
		</template>
		<script>
			import admin from '../../api/admin';
			import { mapState } from 'vuex';
			import { Col, Row,Search,Cell,Toast,DatetimePicker,Field,Popup,Button,Icon,Tab,Tabs } from 'vant';
			export default {
				data () {
					return {
						value:'',
						day_type:1,
						key:'',
						num:'',
						proportion:'',
						sym:'',
						list:[],
						maxDate:new Date(),
						currentDate: new Date(),
						showPicker:false,
						starttime:'',
						endtime:'',
						homeinfo:'',
						all_info:'',
						bbs_list:[],
						bbs_type_list:[],
						top_bbs:{},
						top_comment:{},
						top_bbs_type:{},
						top_keyword:{},
						popName:'',
						active:0,
						params:{
							type:''
						},
						img:{
							hot:require('../../assets/img/hot.png'),
							new: require('../../assets/img/new.png'),
							level1: require('../../assets/img/level1.png'),
							level2: require('../../assets/img/level2.png'),
							level3: require('../../assets/img/level3.png'),
							vie:require('../../assets/img/vie.png'),
							close: require('../../assets/img/close.png'),
						}
					}
				},
				computed: {
					...mapState({
						user: state => state.param.user
					})
				},
				mounted() {
					this.drawkeyLine()
				},
				created () {
					if(this.$route.query.token){
						this.token = this.$route.query.token
						this.$store.dispatch('param/setToken', this.$route.query.token)
						this.getHomeinfo()
						this.getHomelinq()
					}	
					localStorage.setItem('jingpin', true)

				},
				methods: {
					drawkeyLine(){

					},
					onClick(name, title) {
						if(name==1){
							this.params.type=2
							this.getHomeinfo()
							this.getHomelinq()
						}else{
							this.params.type=1
							this.getHomeinfo()
							this.getHomelinq()
						}
						
					},
					getHomelinq(){
						admin.getBbsarr(this.params).then(res => {
							if(res.data.state==1){
								var arrinfo=res.data.data
								this.top_bbs=arrinfo.bbs
								this.top_comment=arrinfo.comment
								this.top_bbs_type=arrinfo.bbs_type
								this.top_keyword=arrinfo.keyword
								var bbsname=res.data.data.name
								for(var i=0;i<bbsname.length;i++){
									bbsname[i]=bbsname[i].replace('雷克萨斯', '');
									bbsname[i]=bbsname[i].replace('论坛', '');
								}
								// let myChart = this.$echarts.init(document.getElementById('myChart'))
								// myChart.setOption({
								// 	tooltip: {
								// 		trigger: 'axis',
								// 		axisPointer: {            
								// 			type: 'shadow'        
								// 		}
								// 	},
								// 	legend: {
								// 		data: [ '帖子数', '评论数'],
								// 		selected: {
								// 			'评论数' : false,
								// 		}
								// 	},
								// 	grid: {
								// 		left: '3%',
								// 		right: '4%',
								// 		bottom: '3%',
								// 		containLabel: true
								// 	},
								// 	xAxis: [
								// 	{
								// 		type: 'category',
								// 		data: bbsname,
								// 		axisLabel: {  
								// 			interval:0,
								// 			formatter:function(value)  
								// 			{  
								// 				return value.split("").join("\n");  
								// 			} 
								// 		}
								// 	}
								// 	],
								// 	yAxis: [
								// 	{
								// 		type: 'value'
								// 	},

								// 	],
								// 	series: [
								// 	{
								// 		name: '帖子数',
								// 		type: 'bar',
								// 		stack: '广告',
								// 		emphasis: {
								// 			focus: 'series'
								// 		},
								// 		itemStyle: {
								// 			color: '#434644'
								// 		},
								// 		data: res.data.data.number
								// 	},
								// 	{
								// 		name: '评论数',
								// 		type: 'bar',
								// 		stack: '广告',
								// 		emphasis: {
								// 			focus: 'series'
								// 		},
								// 		itemStyle: {
								// 			color: '#B9C0C2'
								// 		},
								// 		data: res.data.data.comment_num_all
								// 	}
								// 	]
								// });
							}else{

							}

						})
					},
					getHomeinfo(){
						admin.getAdminhome(this.params).then(res => {
							if(res.data.state==1){
								this.homeinfo=res.data.data
								this.bbs_list=res.data.data.bbs_list
								this.bbs_type_list=res.data.data.bbs_type_list
								this.all_info=res.data.data.all_info
							}else{

							}

						})
					},
					goBbs(id){
						localStorage.setItem('bbsid', id)
						wx.miniProgram.navigateTo({url:'/pages/webview/webview?scene=bbsinfo'})
					},
					goText() {
						wx.miniProgram.navigateTo({url:'/pages/webview/webview?scene=keywordsearch'})
					// this.$router.push({name:'KeywordSearch'});
				},
				goPage(name){
					if(this.token){
						if(this.params.type==2){
							localStorage.setItem('vie', 2)
						}
						wx.miniProgram.navigateTo({url:'/pages/webview/webview?scene='+name})
					}else{
						wx.miniProgram.navigateTo({url:'/pages/login/login'})
					}
				},
				goMorebbs(){
					if(this.params.type==2){
						localStorage.setItem('vie', 2)
					}
					
					wx.miniProgram.navigateTo({url:'/pages/webview/webview?scene=adminmorebbs'})
				},
				goWarnimg(type){
					localStorage.setItem('bbstype', type)
					wx.miniProgram.navigateTo({url:'/pages/webview/webview?scene=keywordwarninginfo'})
				},
				showPop(name){
					this.popName=''
				},
				closePop(){
					this.popName=''
				}
			},
			components: {
				[Col.name]: Col,
				[Row.name]: Row,
				[Search.name]:Search,
				[Cell.name]:Cell,
				[Toast.name]:Toast,
				[DatetimePicker.name]:DatetimePicker,
				[Field.name]:Field,
				[Popup.name]:Popup,
				[Icon.name]:Icon,
				[Button.name]:Button,
				[Tabs.name]:Tabs,
				[Tab.name]:Tab
			}
		}
	</script>
	<style lang="scss">
		.adminkeyword{
			padding:5px 20px;
			.page_background{
				position:fixed;
				top: 0;
				height: 100%;
				width: 100%;
				right: 0;
				left: 0;
				bottom:0;
				background-color:#fff;
			}
			.page_info{
				position: absolute;
				right: 15px;
				bottom: 0;
				top: 0;
				left: 15px;
			}
			.home_stat{
				margin-top: 10px;
				border:1px solid #BBBBBB;
				border-radius:4px;
				padding: 5px 5px;
				.home_stat_top{
					display: flex;
					justify-content: center;
					align-items:center;
					.home_stat_text{
						width: 33.333%;
						font-size: 10px;
						// text-align: center;
						padding: 10px 10px;
						height: 60px;
						text-align: center;
					}
				}
				.home_stat_bottom{
					display: flex;
					justify-content: center;
					align-items:center;
					border-top:1px solid #EEEEEE;
					.home_stat_text{
						width: 33.333%;
						font-size: 12px;
						// text-align: center;
						padding: 10px 10px;

						.home_stat_green{
							color: #1aad19;
						}
						.home_stat_red{
							color: #e15f63;
						}
					}
				}
			}
			.home_btnlistbox{
				.home_btnlist{
					display: flex;
					margin: 5px 0;
					.home_btn{
						width: 33%;
						font-size: 12px;
						color: #333333;
						border:1px solid #BBBBBB;
						padding:12px 0;
						text-align: center;
						border-radius: 4px;

					}
					.margin-10{
						margin: 0 10px;
					}
					.home_btn_active{
						background-color:#DDDDDD;
					}
				}

			}
			.search_box{
				padding:5px 5px 5px 10px;
				display: flex;
				border:1px solid #BBBBBB;
				border-radius:4px;
				align-items:center;
				margin-top: 10px;
				.search_input{
					font-size: 12px;
					color: #999999;
					flex: 1;
					border:0;
				}
				.search_btn{
					width: 75px;
					text-align: center;
					color: #fff;
					font-size: 12px;
					padding:6px 0;
					background-color:#333333;
					border-radius:4px;
				}
			}
			.search_resu{
				margin-top: 25px;
				.home_title{
					color: #666666;
					font-size: 14px;
					font-weight: 400;
					border-bottom:1px solid #EEEEEE;
					padding:0 0 10px 0;
					display: flex;
					align-items: center;
					.home_title_info{
						margin-left: 10px;
						font-size: 9px;
						color: #999999;
						display: flex;
						align-items: center;
					}
				}
				.pop_state{
					position: relative;
					border-radius:4px;
					background-color:#333333;
					color: #fff;
					font-size: 10px;
					padding:10px;
					margin-top: 15px;
					.pop_state_title{
						color: #BBBBBB;
						font-size: 14px;
					}
					.pop_close{
						width: 16px;
						height: 16px;
						position:absolute;
						right: 6px;
						top: 6px;
					}
				}
				.result_box{
					font-size: 12px;
					padding:15px;
					margin-top: 15px;
					border:1px solid #BBBBBB;
					border-radius:4px;
					.result_box_title{
						display: flex;
						align-items:center;
						border-bottom:1px solid #EEEEEE;
						padding:0 10px 10px 10px;
						margin-bottom: 10px;
					}
					.result_title{
						display: flex;
						align-items:center;
						border-bottom:1px solid #EEEEEE;
						padding:0 10px 10px 10px;
						margin-bottom: 10px;
					}
					.result_text{
						display: flex;
						align-items:center;
						padding:10px 10px;
					}
					.result_text_active{
						background-color:#F8F8F8;
					}
					.result_left{
						flex: 1;
					}
					.result_right{
						float: right;
					}
					.result_time{
						flex: 1;
						color: #999999;
						padding-top: 10px;
					}
					.check_more{
						float: right;
						color: #333333;
						padding-top: 10px;
						text-decoration:underline;
					}


				}
				.keyword_box{
					border: 1px solid #BBBBBB;
					border-radius: 4px;
					font-size:12px;
				}
				.bbs_box{
					border:1px solid #BBBBBB;
					border-radius:4px;
					padding:0 10px 10px;
					margin-top: 15px;
					.result_bbsbox{
						font-size: 12px;
						padding:5px;
						margin-top: 15px;
						border-radius:4px;	
						background-color:#F8F8F8;
						.result_bbstit{
							color: #333333;
							font-size: 12px;
							text-decoration:underline;
							border-bottom:1px solid #EEEEEE;
							padding-bottom:10px;
						}
						.result_title_bage{
							width: 36px;
							height: 16px;
							vertical-align:middle;
							margin-left: 10px;
						}
						.result_bbstime{
							color: #999999;
							font-size: 12px;
							padding-top:10px;
							display: flex;
							align-items:center;
						}
					}
					.result_time{
						font-size: 12px;
						flex: 1;
						color: #999999;
						padding-top: 10px;
					}
					.check_more{
						font-size: 12px;
						float: right;
						color: #333333;
						padding-top: 10px;
						text-decoration:underline;
					}
				}
			}
		}
	</style>
